/**
 * @generated SignedSource<<b57212afd88a65d6ab1b44dd40c60183>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_IssueAppWithData_view$data = {
  readonly fieldSets: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldSetId: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "main_issueNavigator_IssueAppWithData_view";
};
export type main_issueNavigator_IssueAppWithData_view$key = {
  readonly " $data"?: main_issueNavigator_IssueAppWithData_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_IssueAppWithData_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "amountOfColumns"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_IssueAppWithData_view",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "fieldSetSelectedState": "SELECTED"
          }
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "amountOfColumns"
        },
        {
          "kind": "Variable",
          "name": "scope",
          "variableName": "fieldSetsScope"
        }
      ],
      "concreteType": "JiraIssueSearchFieldSetConnection",
      "kind": "LinkedField",
      "name": "fieldSets",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraIssueSearchFieldSetEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraIssueSearchFieldSet",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldSetId"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "741c31d0c1ebc1e3fdeb37896e791449";

export default node;
